import React, {useEffect} from 'react';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {useMutation} from '@apollo/client';
import {Button, Form, Input} from 'antd';
import {observer} from 'mobx-react-lite';

import {QUIZ, RESULT_NO_TRY} from '../../config/routes';
import { Store } from '../../model/store/Store';
import {createQuiz, createQuizVariables} from '../../shared/graphql/__generated__/createQuiz';
import {CREATE_QUIZ_MUTATION} from '../../shared/graphql/createQuiz';

import cls from './Index.module.scss'

interface IAnket {
    name: string
    position: string
    email: string
}
export const Anket = observer(() => {

    const [form] = Form.useForm()
    const store = useInstance(Store)
    const navigate = useNavigate()
    const [createQuiz] = useMutation<createQuiz,createQuizVariables>(CREATE_QUIZ_MUTATION)

    useEffect(() => {
        if (store.auth.result !== null) {
            store.auth.clearState()
        }
    }, [store.auth])

    const onFinish = async (values:IAnket) => {
        await createQuiz({
            variables: {
                data: {
                    name: values.name,
                    email: values.email,
                    position: values.position,
                }
            },
            onCompleted: (data) => {
                store.auth.setAuth(true)
                store.auth.setData(
                    data.createQuiz?.data?.attributes?.email!,
                    data.createQuiz?.data?.attributes?.try!,
                    data.createQuiz?.data?.attributes?.createdAt,
                    data.createQuiz?.data?.id!
                    )
                navigate(QUIZ)
            },
            onError: (error) => {
                console.error(error)
                if (error.message === 'Too many') {
                    navigate(RESULT_NO_TRY)
                }
            }
        })
    }

    return (
        <>
            <div className={cls.title}>
                У вас будет ✅✅✅ 3 попытки по 🕓 15 минут, чтобы ответить на вопросы.
                Первые 🥳️️️️️️ 7 человек, кто ответят верно получат 🎁 подарок!<br/><br/>

                Для начала...

            </div>

            <h2>...давайте познакомимся :)</h2>

            <Form form={form} layout={'vertical'} className={cls.form} onFinish={onFinish}>

                <Form.Item name={'name'} label={'Фамилия Имя (Отчество)'} rules={[
                    {required: true, message: 'Пожалуйста заполните'}
                ]}>
                    <Input placeholder={'Тихонов Георгий Романович'}/>
                </Form.Item>

                <Form.Item name={'position'} label={'Должность'} rules={[
                    {required: true, message: 'Пожалуйста заполните'}
                ]}>
                    <Input placeholder={'Ведущий специалист'}/>
                </Form.Item>

                <Form.Item name={'email'} label={'Email'} rules={[
                    {required: true, message: 'Пожалуйста заполните'},
                    {type: 'email', message: 'Не соответствует формату email'}
                ]}>
                    <Input placeholder={'name@example.com'}/>
                </Form.Item>

                <Form.Item>
                    <Button htmlType={'submit'}>Начать викторину</Button>
                </Form.Item>


            </Form>

        </>
    )
})